<template>
	<AdminPageLayout :loading="loading" :error="error">
		<table class="generic-table">
			<thead>
				<tr>
					<th>Email</th>
					<th>Label</th>
					<th>Client secret</th>
					<th>Server secret</th>
					<th>Created</th>
					<th>Actions</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in mtproxies" :key="row.label">
					<td>{{ row.email }}</td>
					<td>{{ row.label }}</td>
					<td>{{ row.client_secret }}</td>
					<td>{{ row.server_secret }}</td>
					<td>{{ $formatDate(row.created) }}</td>
					<td>
						<div class="generic-table-actions">
							<button
								@click="deleteMTProxy(row.label)"
								class="generic-table-action-button"
								:disabled="action_loading"
							>
								Delete
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</AdminPageLayout>
</template>

<script>
import AdminPageLayout from './_PageLayout.vue'

export default {
	name: 'AdminMTProxy',
	components: {
		AdminPageLayout
	},
	data() {
		return {
			loading: true,
			action_loading: false,
			error: '',
			mtproxies: []
		}
	},
	async mounted() {
		await this.fetchMTProxy()
	},
	methods: {
		async fetchMTProxy() {
			this.loading = true
			this.error = ''

			const authToken = localStorage.getItem('authToken')?.trim()
			if (!authToken || authToken === 'null') {
				this.$router.push({ name: 'Login' })
				return
			}

			try {
				const response = await this.$api.post('/api/admin/mtproxy', {
					authToken: authToken
				})

				this.mtproxies = response.data.mtproxies || []
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else {
					this.error = 'An error occurred while loading MTProxy entries.'
					console.error('Error:', error)
				}
			} finally {
				this.loading = false
			}
		},
		async deleteMTProxy(label) {
			this.action_loading = true
			this.error = ''
			const authToken = localStorage.getItem('authToken')?.trim()

			try {
				await this.$api.post('/api/admin/mtproxy/delete', {
					authToken: authToken,
					label: label
				})
				await this.fetchMTProxy()
			} catch (error) {
				if (error.response && error.response.status === this.$StatusCodes.UNAUTHORIZED) {
					localStorage.removeItem('authToken')
					this.$router.push({ name: 'Login' })
				} else if (error.response && error.response.status === this.$StatusCodes.NOT_FOUND) {
					this.error = 'MTProxy entry not found.'
				} else {
					this.error = 'An error occurred while deleting MTProxy entry.'
					console.error('Error:', error)
				}
			} finally {
				this.action_loading = false
			}
		}
	}
}
</script>

<style scoped>
</style>
